import * as React from 'react';
import { Outer, Inner, BrandImg, Spacer, SocialIconGroup, SocialIconText, SocialIconLink, SocialIconImg } from './Social.styles';
import LOGO_AU from '../Social/images/logo-latitude.svg';
import LOGO_NZ from '../Social/images/logo-gemfinance.svg';
export default (_ref => {
  let {
    data,
    isNz = false
  } = _ref;
  const logoUrl = isNz ? LOGO_NZ : LOGO_AU;
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(BrandImg, {
    src: logoUrl
  }), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(SocialIconGroup, null, /*#__PURE__*/React.createElement(SocialIconText, null, "Connect with us"), data.map((item, i) => /*#__PURE__*/React.createElement(SocialIconLink, {
    key: i,
    href: item.link,
    noStyle: true,
    target: "_blank",
    trackEventData: item.trackEventData
  }, /*#__PURE__*/React.createElement(SocialIconImg, {
    src: require(`./images/${item.icon}.svg`),
    alt: item.title
  }))))));
});